import { ShippingTrackingResult } from "@dana/Services/DanaOrderRelatedService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

// Define the state type for this fetch workflow
export interface DanaShippingTrackingState {
    isLoading: boolean,   
    data: any,    // Use a more specific type if known
    error: string | null,
}

const initialShippingTrackingState: DanaShippingTrackingState = {
    isLoading: false,   
    data: null,
    error: null
};

// Create Immer reducer
const danaShippingTrackingReducer = createTypedReducerWithImmer(initialShippingTrackingState, {
    // Start loading
    "DanaShippingTracking/IsLoading": (draft, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null; // Optionally reset error if reloading
        }
    },

    // Populate result on success
    "DanaShippingTracking/PopulateResult": (draft, action: { data: ShippingTrackingResult }) => {       
        draft.data = action.data;       
        draft.isLoading = false;
        draft.error = null;
    },

    // Handle error
    "DanaShippingTracking/FetchError": (draft, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    // Reset all state (optional)
    "DanaShippingTracking/Reset": draft => {
        draft.isLoading = false;
        draft.data = null;
        draft.error = null;
    }
});

// Register reducer in the root
(reducers as any).danaShippingTracking = danaShippingTrackingReducer;

// Define type for action usage
type DanaShippingTrackingReducers = {
    danaShippingTracking: typeof danaShippingTrackingReducer;
};

export type DanaShippingTrackingActions = Parameters<DanaShippingTrackingReducers[keyof DanaShippingTrackingReducers]>[1] | AnyAction;
